<template>
    <div>
		
        <div class="page-filter-box">
            <el-row :gutter="20">				
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-input v-model="params.keywords" class="input-with-select" size="small" >
				        <el-select v-model="bindType2" slot="prepend" placeholder="请选择" size="medium">
				            <el-option label="模板名称" :value="1"></el-option>
				        </el-select>
				    </el-input>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.bindType" placeholder="请选择" size="small">
				        <el-option label="仅查看通用模板" :value="1"></el-option>
				        <el-option label="仅查看有绑定对象的模板" :value="2"></el-option>
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="4" v-if="params.bindType == 2">
				    <el-input v-model="params.keywords2" class="input-with-select" size="small" ></el-input>
				</el-col> 
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.type" placeholder="请选择" size="small">
                        <el-option label="不限二级分类" value=""></el-option>
                        <el-option v-for="(item, index) in typeList" :key="index" :label="`仅看${item.label}的`" :value="item.value"></el-option>
                    </el-select>
                </el-col>				
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div v-if="$utils.have('/service/template/create')" class="page-btns-box">
            <el-button type="primary" icon="el-icon-plus" @click="add(1,1)"
                size="small">新增服务模板</el-button>
			<el-button type="primary" icon="el-icon-sort" @click="sort()"
			    size="small">二级分类排序</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
				<el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="title" label="名称" min-width="150" show-overflow-tooltip></el-table-column>
                <!-- <el-table-column label="所属业务">
                    <template slot-scope="scope">
                        {{ scope.row.businessType && (scope.row.businessType === 1 ? '演出' : scope.row.businessType === 2 ?
                            '周边' : '其他') }}
                    </template>
                </el-table-column> -->
                <el-table-column prop="type" label="分类">
                    <template slot-scope="{row} = scope">
                        服务说明 / {{ typeList.find(v => v.value === row.type).label }}
                    </template>
                </el-table-column>
				<el-table-column prop="bindIds" label="绑定对象" min-width="100" show-overflow-tooltip></el-table-column>
				<el-table-column prop="modifyUserName" label="最近更新人" min-width="100" show-overflow-tooltip></el-table-column>
				<el-table-column prop="modifyTime" label="最近更新时间" min-width="150"></el-table-column>				
                <el-table-column v-if="$utils.have('/service/template/update')" fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" icon="el-icon-edit" @click="edit(scope.row.id,1,1)">编辑</el-button>
                        <el-button v-if="$utils.have('/service/template/delete')" type="text" size="small"
                            icon="el-icon-delete" @click="del(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>
		<type-sort ref="typeSort" :type="1"></type-sort>
    </div>
</template>
<script>
import {fetchServiceTemplateType} from  '@/assets/js/commonApi'
import typeSort from './type-sort'

const defaultParams = {
    pageNo: 1,
    businessType: 1,
    type: "",
	bindType:1,
	keywords2:'',
	keywords:'',
	category:1
}
export default {
	components:{typeSort},
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                // businessType: parseInt(this.$route.query.businessType) || "",
                type: parseInt(this.$route.query.type) || "",
				keywords2: this.$route.query.value || '',
				keywords: this.$route.query.value || ''
            },
            listLoading: true,
            typeList: [],
			bindType2:1,
			
        };
    },
    mounted() {
		const _typeList = fetchServiceTemplateType();		
		this.typeList = _typeList.filter((item) => item.value == 1);
        this.getDataList();
    },
	computed: {
		businessType() {
			return new Map([				
				[1, '演出'],
				[2, '周边'],
				[3, '其它'],
			])
		},
		
	},
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/service/template/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
		sort(){
			 this.$refs.typeSort.show();
		},
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            }
            this.getDataList();
        },
		add(type,minitype){
			this.$router.replace({
			    path: `/system/serviceTemplate/add/${type}/${minitype}`,
			    query: {
			        v: this.$utils.uuid(),
			        redirect: this.$utils.objArgs(
			            this.$router.currentRoute.path,
			            this.params
			        ),
			    },
			});
		},
        //编辑
        edit(id,type,minitype) {
            this.$router.replace({
                path: `/system/serviceTemplate/edit/${id}/${type}/${minitype}`,
                query: {
                    v: this.$utils.uuid(),
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },
        //删除事件
        del(id) {
            this.$confirm('确定要删除吗?', '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: '/service/template/delete',
                    method: 'POST',
                    params: { id: id }
                }).then(res => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.getDataList();
                    } else {
                        this.$message.error(msg || '请求失败');
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.listLoading = false;
                });
            })
        }
    },
};
</script>
